import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import * as actions from '../../store/actions/index';
import Message from './Message.js';
import PropTypes from 'prop-types';
var moment = require('moment');

class ChatroomEnquirySettlement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uniqueId: localStorage.getItem('token'),
            username: this.props.clientName,
            userSent: true,
            typeOfAccount:localStorage.getItem('typeOfAccount')
        };
        this.submitMessage = this.submitMessage.bind(this);
        this.props.getCaseInfo(localStorage.getItem('caseId'), localStorage.getItem('token'));
    }

    componentDidMount() {
        //this.props.getCaseInfo(this.props.caseId);
        this.props.getAllChatMsgEnquirySettlement(this.props.caseId);

        if (this.state.uniqueId == this.props.claimantUniqueId){
            this.setState({
                username: this.props.claimant_name
            });
        }
        else if (this.state.uniqueId == this.props.respondentUniqueId){
            this.setState({
                username: this.props.respondent_name
            });
        }
        else if (this.state.typeOfAccount == 'admin'){
            this.setState({
                username: 'HKAS'
            });
        }
        else if (this.state.typeOfAccount == 'arbitrator'){
            this.setState({
                username: 'Arbitrator'
            });
        }

        this.internalTimer = setInterval(()=>{

            this.props.getAllChatMsgEnquirySettlement(this.props.caseId);

            if (this.state.uniqueId == this.props.claimantUniqueId){
                this.setState({
                    username: this.props.claimant_name
                });
            }
            else if (this.state.uniqueId == this.props.respondentUniqueId){
                this.setState({
                    username: this.props.respondent_name
                });
            }
            else if (this.state.typeOfAccount == 'admin'){
                this.setState({
                    username: 'HKAS'
                });
            }
            else if (this.state.typeOfAccount == 'arbitrator'){
                this.setState({
                    username: 'Arbitrator'
                });
            }

        },2000)

        this.scrollToBot();
          
    }

    componentWillUnmount(){
        if (this.internalTimer) {
            clearInterval(this.internalTimer);
            this.internalTimer = null;
        }
        this.props.clearAllChatMsgEnquirySettlement()
    }

    componentDidUpdate() {
        // console.log('componentDidUpdate: userSent: '+this.state.userSent)
        if (this.state.userSent){
            this.scrollToBot();
            this.scrollToBot();
            this.scrollToBot();
            console.log('componentDidUpdate: scrollToBot ')
            setTimeout(()=>{
                this.setState({
                    userSent:false
                })
            },2500)
        }
    }

    scrollToBot() {
        ReactDOM.findDOMNode(this.refs.chats).scrollTop = ReactDOM.findDOMNode(this.refs.chats).scrollHeight;
    }

    submitMessage(e) {
        e.preventDefault();

        console.log('ChatroonEnquriySettlement this.props.userType: '+this.props.userType);
        console.log('ChatroonEnquriySettlement this.props.clientName: '+this.props.clientName);
        console.log('ChatroonEnquriySettlement this.state.username: '+this.state.username);

        console.log('ChatroonEnquriySettlement this.props.claimant_name: '+this.props.claimant_name);
        console.log('ChatroonEnquriySettlement this.props.respondent_name: '+this.props.respondent_name);

        console.log('ChatroonEnquriySettlement this.props.claimantUniqueId: '+this.props.claimantUniqueId);
        console.log('ChatroonEnquriySettlement this.props.respondentUniqueId: '+this.props.respondentUniqueId);

        if (this.state.uniqueId == this.props.claimantUniqueId){
            this.setState({
                username: this.props.claimant_name
            });
        }
        else if (this.state.uniqueId == this.props.respondentUniqueId){
            this.setState({
                username: this.props.respondent_name
            });
        }
        else if (this.state.typeOfAccount == 'admin'){
            this.setState({
                username: 'HKAS'
            });
        }
        else if (this.state.typeOfAccount == 'arbitrator'){
            this.setState({
                username: 'Arbitrator'
            });
        }

        if ((this.refs.msg).value !== ''){
            var timestamp = moment().format('MMM Do YYYY, h:mm a');

            let uniqueId = localStorage.getItem('token');
            let userType = '';
                if(this.props.claimantUniqueId == uniqueId){
                    userType = 'claimant';
                }else if(this.props.respondentUniqueId == uniqueId){
                    userType = 'respondent';
                }
                else if (localStorage.getItem('typeOfAccount') == 'admin'){
                    userType = 'admin'
                }
                else if (localStorage.getItem('typeOfAccount') == 'arbitrator'){
                    userType = 'arbitrator'
                }

            this.props.saveChatMsgEnquirySettlement({
                caseId:this.props.caseId,
                username:this.state.username,
                content:(this.refs.msg).value,
                timestamp:timestamp,
                userType:userType
            });

            this.setState({
                // userSent:true
            }, () => {
                ReactDOM.findDOMNode(this.refs.msg).value = "";
            });

            this.setState({
                userSent:true
            })

            this.scrollToBot();

        }
    }

    render() {
        
        return (
            <div 
            className="chatroom"
            style={{    width: '99%',
                        marginBottom:'10px',
                        minHeight: '400px',
                        zoom: 1,
                        transform: 'translateZ(0)',
                        WebkitTransform: 'translateZ(0)',
                        }}>
                <h3 style={{ color:'#a52423', bold:'true', wordWrap: 'breakWord', marginTop:'10px', whiteSpace: 'normal', fontSize:'14px', fontFamily:'Times New Roman Georgia' }}>
                    {this.context.t('The Parties and the Arbitrator can make Preliminary Enquiries')} <br></br> 
                    { localStorage.getItem('language') == 'en' ? this.context.t('Submission, Interrogatories and Enquiries in this chatroom') :''}.</h3>
                <ul className="chats" ref="chats" style={{zoom: 1, overflow: 'scroll'}}>
                    {
                        this.props.chats.map((chat, index) => 
                            <Message key={chat.timestamp + '_' + index} chat={chat} user={this.state.username} />
                        )
                    }
                </ul>
                
                    <form className="input" style={{marginBottom:'5px', marginRight:'10px'}} onSubmit={(e) => this.submitMessage(e)}>
                    <input type="text" ref="msg" style={{width:'93%'}} />
                    <input type="submit" value={this.context.t('Send')}  style={{marginRight:'10px'}} />
                    </form>
                
                
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    let uniqueId = localStorage.getItem('token');
    let userType = '';
        if(state.caseInfo.caseData.claimantUniqueId == uniqueId){
            userType = 'claimant';
        }else if(state.caseInfo.caseData.respondentUniqueId == uniqueId){
            userType = 'respondent';
        }
        else if (localStorage.getItem('typeOfAccount') == 'admin'){
            userType = 'admin'
        }
        else if (localStorage.getItem('typeOfAccount') == 'arbitrator'){
            userType = 'arbitrator'
        }

    if (state.caseInfo.caseData.agreement_type == 'EstateAgentDispute'){
        
        if ((state.caseInfo.caseData.a2  == 'purchaser' || state.caseInfo.caseData.a2  == 'vendor') && state.caseInfo.caseData.a1 == undefined){

            if (userType == 'claimant'){
           
                return {
                    caseId: state.caseInfo.caseId,
                    claimantUniqueId: state.caseInfo.claimantUniqueId,
                    respondentUniqueId: state.caseInfo.respondentUniqueId,
                    caseData: state.caseInfo.caseData,
                    claimant_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                    respondent_name: state.caseInfo.caseData.a12,
                    userType: state.caseInfo.userType,
                    clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                    chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                    addChatError: state.chatroom.addChatEnquirySettlementError,
                    getChatError: state.chatroom.getChatEnquirySettlementError,
                }

            }
            else if (userType == 'respondent'){

                return {
                    caseId: state.caseInfo.caseId,
                    claimantUniqueId: state.caseInfo.claimantUniqueId,
                    respondentUniqueId: state.caseInfo.respondentUniqueId,
                    caseData: state.caseInfo.caseData,
                    claimant_name: state.caseInfo.caseData.namesOfPurchasers[0].a4,
                    respondent_name: state.caseInfo.caseData.a12,
                    userType: state.caseInfo.userType,
                    clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                    chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                    addChatError: state.chatroom.addChatEnquirySettlementError,
                    getChatError: state.chatroom.getChatEnquirySettlementError,
                }
                
            }
            else if (userType == 'admin'){
              
                return {
                    caseId: state.caseInfo.caseId,
                    claimantUniqueId: state.caseInfo.claimantUniqueId,
                    respondentUniqueId: state.caseInfo.respondentUniqueId,
                    caseData: state.caseInfo.caseData,
                    claimant_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                    respondent_name: state.caseInfo.caseData.a12,
                    userType: state.caseInfo.userType,
                    clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                    chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                    addChatError: state.chatroom.addChatEnquirySettlementError,
                    getChatError: state.chatroom.getChatEnquirySettlementError,
                }
                
            }
            else if (userType == 'arbitrator'){
              
                return {
                    caseId: state.caseInfo.caseId,
                    claimantUniqueId: state.caseInfo.claimantUniqueId,
                    respondentUniqueId: state.caseInfo.respondentUniqueId,
                    caseData: state.caseInfo.caseData,
                    claimant_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                    respondent_name: state.caseInfo.caseData.a12,
                    userType: state.caseInfo.userType,
                    clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                    chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                    addChatError: state.chatroom.addChatEnquirySettlementError,
                    getChatError: state.chatroom.getChatEnquirySettlementError,
                }
                
            }

        }
        else{
            if (userType == 'claimant'){
                if (state.caseInfo.caseData.a3 !== undefined){
                    
                    if (state.caseInfo.caseData.a1 == 'sole'){
                    
                        if (state.caseInfo.caseData.a2 == 'vendor'){
                            return {
                                caseId: state.caseInfo.caseId,
                                claimantUniqueId: state.caseInfo.claimantUniqueId,
                                respondentUniqueId: state.caseInfo.respondentUniqueId,
                                caseData: state.caseInfo.caseData,
                                claimant_name: state.caseInfo.caseData.a3,
                                respondent_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                                userType: state.caseInfo.userType,
                                clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                                chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                                addChatError: state.chatroom.addChatEnquirySettlementError,
                                getChatError: state.chatroom.getChatEnquirySettlementError,
                            }
                        }
                        else if (state.caseInfo.caseData.a2 == 'purchaser'){
                            return {
                                caseId: state.caseInfo.caseId,
                                claimantUniqueId: state.caseInfo.claimantUniqueId,
                                respondentUniqueId: state.caseInfo.respondentUniqueId,
                                caseData: state.caseInfo.caseData,
                                claimant_name: state.caseInfo.caseData.a3,
                                respondent_name: state.caseInfo.caseData.namesOfPurchasers[0].a12a,
                                userType: state.caseInfo.userType,
                                clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                                chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                                addChatError: state.chatroom.addChatEnquirySettlementError,
                                getChatError: state.chatroom.getChatEnquirySettlementError,
                            }
                        }
        
                    }
                    else if (state.caseInfo.caseData.a1 == 'seperate'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfA2[0].a4,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }

                }
            }
            else if (userType == 'respondent'){

                if (state.caseInfo.caseData.a1 == 'sole'){
                    
                    if (state.caseInfo.caseData.a2 == 'vendor'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }
                    else if (state.caseInfo.caseData.a2 == 'purchaser'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfPurchasers[0].a12a,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }

                }
                else if (state.caseInfo.caseData.a1 == 'seperate'){
                    return {
                        caseId: state.caseInfo.caseId,
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        caseData: state.caseInfo.caseData,
                        claimant_name: state.caseInfo.caseData.a3,
                        respondent_name: state.caseInfo.caseData.namesOfA2[0].a4,
                        userType: state.caseInfo.userType,
                        clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                        chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                        addChatError: state.chatroom.addChatEnquirySettlementError,
                        getChatError: state.chatroom.getChatEnquirySettlementError,
                    }
                }
                
            }
            else if (userType == 'admin'){
                if (state.caseInfo.caseData.a1 == 'sole'){
                    
                    if (state.caseInfo.caseData.a2 == 'vendor'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }
                    else if (state.caseInfo.caseData.a2 == 'purchaser'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfPurchasers[0].a12a,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }

                }
                else if (state.caseInfo.caseData.a1 == 'seperate'){
                    return {
                        caseId: state.caseInfo.caseId,
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        caseData: state.caseInfo.caseData,
                        claimant_name: state.caseInfo.caseData.a3,
                        respondent_name: state.caseInfo.caseData.namesOfA2[0].a4,
                        userType: state.caseInfo.userType,
                        clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                        chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                        addChatError: state.chatroom.addChatEnquirySettlementError,
                        getChatError: state.chatroom.getChatEnquirySettlementError,
                    }
                }
            }
            else if (userType == 'arbitrator'){
                if (state.caseInfo.caseData.a1 == 'sole'){
                    
                    if (state.caseInfo.caseData.a2 == 'vendor'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfVendors[0].a4,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }
                    else if (state.caseInfo.caseData.a2 == 'purchaser'){
                        return {
                            caseId: state.caseInfo.caseId,
                            claimantUniqueId: state.caseInfo.claimantUniqueId,
                            respondentUniqueId: state.caseInfo.respondentUniqueId,
                            caseData: state.caseInfo.caseData,
                            claimant_name: state.caseInfo.caseData.a3,
                            respondent_name: state.caseInfo.caseData.namesOfPurchasers[0].a12a,
                            userType: state.caseInfo.userType,
                            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                            chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                            addChatError: state.chatroom.addChatEnquirySettlementError,
                            getChatError: state.chatroom.getChatEnquirySettlementError,
                        }
                    }

                }
                else if (state.caseInfo.caseData.a1 == 'seperate'){
                    return {
                        caseId: state.caseInfo.caseId,
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        caseData: state.caseInfo.caseData,
                        claimant_name: state.caseInfo.caseData.a3,
                        respondent_name: state.caseInfo.caseData.namesOfA2[0].a4,
                        userType: state.caseInfo.userType,
                        clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
                        chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
                        addChatError: state.chatroom.addChatEnquirySettlementError,
                        getChatError: state.chatroom.getChatEnquirySettlementError,
                    }
                }
            }
        }


    }
    else if (state.caseInfo.caseData.agreement_type == 'MoneyLent'){
        return {
            caseId: state.caseInfo.caseId,
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            caseData: state.caseInfo.caseData,
            claimant_name: state.caseInfo.claimant_name,
            respondent_name: state.caseInfo.respondent_name,
            userType: state.caseInfo.userType,
            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
            chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
            addChatError: state.chatroom.addChatEnquirySettlementError,
            getChatError: state.chatroom.getChatEnquirySettlementError,
        }
    }
    else if (state.caseInfo.caseData.agreement_type == 'other_dispute'){
        return {
            caseId: state.caseInfo.caseId,
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            caseData: state.caseInfo.caseData,
            claimant_name: state.caseInfo.caseData.a1,
            respondent_name: state.caseInfo.caseData.a9,
            userType: state.caseInfo.userType,
            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
            chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
            addChatError: state.chatroom.addChatEnquirySettlementError,
            getChatError: state.chatroom.getChatEnquirySettlementError,
        }
    }
    else if (state.caseInfo.caseData.agreement_type == 'SalesOfGoods' || state.caseInfo.caseData.agreement_type == 'serviceDispute' || 
    state.caseInfo.caseData.agreement_type == 'insuranceDispute'){
        return {
            caseId: state.caseInfo.caseId,
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            caseData: state.caseInfo.caseData,
            claimant_name: state.caseInfo.caseData.a1,
            respondent_name: state.caseInfo.caseData.a9,
            userType: state.caseInfo.userType,
            clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
            chats: state.chatroomEnquirySettlement.payloadEnquirySettlement,
            addChatError: state.chatroom.addChatEnquirySettlementError,
            getChatError: state.chatroom.getChatEnquirySettlementError,
        }
    }


}

const mapDispatchToProps = (dispatch) => {
    return {
           //getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
           saveChatMsgEnquirySettlement: (payload) => dispatch(actions.saveChatMsgEnquirySettlement(payload)),
           getAllChatMsgEnquirySettlement: (caseId) => dispatch(actions.getAllChatMsgEnquirySettlement(caseId)),
           clearAllChatMsgEnquirySettlement: () => dispatch(actions.clearAllChatMsgEnquirySettlement()),
           
           getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
    }
}

ChatroomEnquirySettlement.contextTypes = {
    t: PropTypes.func
  }

export default (connect(mapStateToProps, mapDispatchToProps)(ChatroomEnquirySettlement));